import { Modal, Button, Image } from 'react-bootstrap'
import { useState } from 'react'
import {  FaFacebookF, FaEnvelope } from "react-icons/fa";
import Link from 'next/link'
import { CreateAccount } from '../Block'

function ModalMsg() {
  const [show, setShow] = useState(true);
  const [showCAccount, setShowCAccount] = useState(false);
  const handleClose = () => setShow(false);


  return (
    
    <Modal size="lg" show={show} onHide={handleClose}>
      <Modal.Header closeButton>
      <Modal.Title className="h5">Get Unlimited VIP Access to FREE Wellness Resources!</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pb-5">
          <div className="d-lg-flex">
            <div className="text-center mx-2">
            <h2 className="h5">This food is yummy and healthy</h2>
            <p>Read this insightful article today!</p>
            <Image width="377" height="248" src="https://placeimg.com/640/480/animals" />
            </div>
            <div className="mx-3 h7">
                {!showCAccount &&
                <>
                <p><strong>Hi Anne, it’s nice to see you!</strong></p>
                <p>This is part of my personal library of wellness resources and it’s exclusively for my wellness project community</p>
                <p><strong>You’re one of my loyal e-newsletter subscribers</strong> but it seems you haven’t created your FREE wellness project account yet.</p> 
                <p> This means you can only access the content directly connected to my newsletter. <strong>I’d like to invite you to join </strong>my VIP community and get unlimited access to everything.</p>
                <p>Thanks in advance for joining! <br/> See you inside</p>
                <p>Jody</p>
                </>
                }
                <Button className="minw"><FaFacebookF className="mr-2"/><span className="border-left ml-2 pl-3 pr-3 ">Join using facebook</span></Button>
                <p className="mt-3 text-center minw">or</p>
                <Button onClick={() => setShowCAccount(!showCAccount)} className="btn-green border-green minw"><FaEnvelope className="mr-2"/><span className="border-left ml-2 pl-3 pr-3">Join using email</span></Button>
                {!showCAccount &&
                <Link href=""><a className="h7 d-block mt-2">Dicover ALL the Benefits of VIP Access</a></Link>
                }
                {showCAccount && 
                <CreateAccount/>
                }
            </div>
          </div>
      </Modal.Body>       
    </Modal>
  );
}
      
     
export default ModalMsg;
